import styled from '@emotion/styled';

const ReportActionsRow = styled.div`
  display: flex;
  width: max-content;
  max-width: 100%;
  min-width: max-content;
  margin-left: auto;
  justify-content: flex-end;
  align-items: center;
  flex-wrap: nowrap;
  gap: ${({ theme }) => theme.spacing(1)};

  > * {
    flex: 0 0 auto;
  }
`;

export default ReportActionsRow;
